import _extends from "@babel/runtime/helpers/esm/extends";
import Box from '@mui/material/Box';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export function Dot(props) {
  var color = props.color,
    _props$size = props.size,
    size = _props$size === void 0 ? 8 : _props$size,
    sx = props.sx;
  return /*#__PURE__*/_jsx(Box, {
    sx: _extends({
      background: color,
      borderRadius: '50%',
      height: "".concat(size, "px"),
      padding: '1px',
      width: "".concat(size, "px")
    }, sx),
    "data-element": "Box",
    "data-component": "Dot",
    "data-source-file": "Dot.tsx"
  });
}